import React, { useEffect, useState } from "react";
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';
import stilePulsanti from "../../../interfaccia/stilePulsanti";
import InputDatoProdotto from "../../../modificaProdotti/elementiPagina/InputDatoProdotto";
import _ from "lodash";
import apiUrl from "../../../Apiurl";
/* import InputDatoTendinaGenerico from "../../../modificaProdotti/elementiPagina/InputDatoTendinaGenerico";
import InputTendinaDatoProdotto from "../../../modificaProdotti/elementiPagina/InputTendinaDatoProdotto";
import InputBoolean from "../../../modificaProdotti/elementiPagina/InputBoolean"; */
import ListaAssocia from "../../componenti/ListaAssocia";
import RiquadrinoFornitore from "../../../logistica/AreaOrdiniComponenti/OrdineComponenti/RiquadrinoFornitore";
import RiquadrinoContatto from "../../../logistica/AreaOrdiniComponenti/OrdineComponenti/RiquadrinoContatto";

function ModificaBrands({
    elemento,
    setElemento,
    utente,
    mobile
}) {


    const {
        buttonClassesRed,
        buttonClassesGreen,
        classiTastoSblocco,
        inputClassesNOW,
        riquadroClassesRed,
    } = stilePulsanti

    let classDivPrincipale = "fixed-l w-100-l sfondoColChiaro h-100 colonnaTuttaPagina-ns flex justify-center"


    ///// HOOKS //////////////////

    const [brandTemp, setBrandTemp] = useState(elemento);
    const [salvato, setSalvato] = useState(true);
    const { user, /* isAuthenticated, */ getAccessTokenSilently } = useAuth0();
    const [token, setToken] = useState("");
    const [alert, setAlert] = useState("");
    const [resultSalvataggio, setResultSalvataggio] = useState(false);
    const [alertSalvataggio, setAlertSalvataggio] = useState(false);


    ///// FUNZIONI ///////////////

    useEffect(() => {
        const getUserMetadata = async () => {
            try {
                const accessToken = await getAccessTokenSilently();
                setToken(accessToken);
            } catch (e) {
                console.log(e.message);
            }
        };
        getUserMetadata();
    }, [getAccessTokenSilently, user?.sub]);

    const handleChange = async function (evt) {
        setSalvato(false);
        const value = evt.target.value;
        try {
            if (evt.target.name.includes(".") || evt.target.name.includes("[")) {
                const update = _.set(_.cloneDeep(brandTemp), evt.target.name, value) // METODO RESOURCE EXPENSIVE
                setBrandTemp(update)
            } else if (!evt.target.name.includes(".") && !evt.target.name.includes("[")) {
                setBrandTemp({
                    ...brandTemp,
                    [evt.target.name]: value
                });
            } else {
                setAlert("Errore cambio dato")
            }
        } catch (err) {
            console.log("Errore nell'aggiornamento di un dato nestato: " + err)
            throw err;
        }
    }


    async function salvaProdotto(e) {
        e.preventDefault();
        if (!token) {
            console.warn("sto aspettando un token")
            return;
        }
        try {
            const data = {
                brand: brandTemp
                /* utente: utente.username,
                permessi: utente.permessiAPI */
            }
            const config = {
                headers: {
                    'Authorization': 'Bearer ' + token,
                }
            }
            axios.patch(apiUrl + "/anagrafiche/salvaBrand", data, config)
                .then((resp) => {
                    if (resp.data.errno) {
                        setAlertSalvataggio(`Errore nel salvataggio: ${resp.data.code} - ${resp.data.message}`)
                    } else {
                        setAlertSalvataggio(false)
                        setResultSalvataggio(resp.data)
                        setSalvato(true);
                        setElemento(false);
                    }
                })
        } catch (err) {
            console.log("Errore nell'invio del prodotto alle API': " + err)
            throw err;
        }
    }

    async function salvaProdottoSenzaChiudere(e) {
        e.preventDefault();
        if (!token) {
            console.warn("sto aspettando un token")
            return;
        }
        try {
            const data = {
                brand: brandTemp
                /* utente: utente.username,
                permessi: utente.permessiAPI */
            }
            const config = {
                headers: {
                    'Authorization': 'Bearer ' + token,
                }
            }
            axios.patch(apiUrl + "/anagrafiche/salvaBrand", data, config)
                .then((resp) => {
                    if (resp.data.errno) {
                        setAlertSalvataggio(`Errore nel salvataggio: ${resp.data.code} - ${resp.data.message}`)
                    } else {
                        setBrandTemp({
                            ...brandTemp,
                            id: resp.data.insertId
                        });
                        setAlertSalvataggio(false)
                        setResultSalvataggio(resp.data)
                        setSalvato(true);
                    }
                })
        } catch (err) {
            console.log("Errore nell'invio del prodotto alle API': " + err)
            throw err;
        }
    }

    function chiudiSenzaSalvare(e) {
        e.preventDefault()
        setElemento(false)
    }

    //////////// RIQUADRINI DA PASSARE A LISTE ASSOCIAZIONI

    function listaRiquadriFornitori (el,funzioneRimuovi) {
        return(<RiquadrinoFornitore  
            elemento={el}
            rimuoviAssociazione={funzioneRimuovi}
            /* funzioneScegliID={funzioneScegliID} */
            scelto={true}
        />)
    }

    



    /////////////////////////////////////////// COLONNE /////////////////////////////////////

    function riquadroSalvataggio() {
        return (
            <div>
                {alertSalvataggio && <div className={riquadroClassesRed + " mb2"}>{alertSalvataggio}</div>}
                {!salvato && <button className={buttonClassesGreen + " mb2"} onClick={salvaProdottoSenzaChiudere}>Salva</button>}
                {!salvato && <button className={buttonClassesGreen + " mb2"} onClick={salvaProdotto}>Salva e chiudi</button>}
                {!salvato && <button className={buttonClassesRed + " mb2"} onClick={chiudiSenzaSalvare}>Chiudi senza salvare</button>}
                {salvato && <button className={buttonClassesGreen + " mb2"} onClick={chiudiSenzaSalvare}>Chiudi</button>}
                {alert && <h3 className="tastoRosso white">{alert}</h3>}
                {resultSalvataggio && <h3 className="tastoRosso white">{resultSalvataggio}</h3>}
            </div>
        )
    }

    const linkWrite = <div><a href={brandTemp["linkFolderWrite"]}  target="_blank" rel="noopener noreferrer" className={stilePulsanti.buttonClassesWhite+" flex items-center justify-center"}><span className='material-icons f3 mr2'>folder</span> CARTELLA ONEDRIVE</a></div>
    const linkRead = <div><a href={brandTemp["linkFolderRead"]}  target="_blank" rel="noopener noreferrer" className={stilePulsanti.buttonClassesWhite+" flex items-center justify-center"}><span className='material-icons f3 mr2'>folder</span> CARTELLA ONEDRIVE</a></div>

    function riquadroDatiBrand() {
        return (
            <div className="mb3">
                <h2>{brandTemp.nome}</h2>
                {(utente.permessiAPI["update:database"] && brandTemp["linkFolderWrite"]) && linkWrite}
                {((!utente.permessiAPI["update:database"] && utente.permessiAPI["read:database"] && brandTemp["linkFolderRead"]) || (utente.permessiAPI["update:database"] && brandTemp["linkFolderRead"] && !brandTemp["linkFolderRead"])) && linkRead}
                {!brandTemp.id && 
                    <InputDatoProdotto
                    inputLabel="Nome"
                    datoName='nome'
                    datoId="nome"
                    datoValue={brandTemp.nome ?? ""}
                    datoPlaceHolder=""
                    datoOnChange={handleChange}
                    inputClass={inputClassesNOW + " w-80 h-100"}
                    datoClass={"w-100"}
                    labelClass={"wpx-60"}
                    classiTastoSblocco={classiTastoSblocco}
                    tastoCopiaAspetto="NO"
                    modCompatta="SI"
                    permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                }
                {/* <h2>{brandTemp.nomeFornitore}</h2> */}
                <div className="mt3 mb3 flex flex-wrap">
                    <InputDatoProdotto
                    inputLabel="Cartella permessi lettura"
                    datoName='linkFolderRead'
                    datoId="linkFolderRead"
                    datoValue={brandTemp.linkFolderRead ?? ""}
                    datoPlaceHolder=""
                    datoOnChange={handleChange}
                    inputClass={inputClassesNOW + " w-80 h-100"}
                    datoClass={"w-100"}
                    labelClass={"wpx-60"}
                    classiTastoSblocco={classiTastoSblocco}
                    tastoCopiaAspetto="NO"
                    modCompatta="SI"
                    permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                    <InputDatoProdotto
                    inputLabel="Cartella permessi scrittura"
                    datoName='linkFolderWrite'
                    datoId="linkFolderWrite"
                    datoValue={brandTemp.linkFolderWrite ?? ""}
                    datoPlaceHolder=""
                    datoOnChange={handleChange}
                    inputClass={inputClassesNOW + " w-80 h-100"}
                    datoClass={"w-100"}
                    labelClass={"wpx-60"}
                    classiTastoSblocco={classiTastoSblocco}
                    tastoCopiaAspetto="NO"
                    modCompatta="SI"
                    permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                    {/* <InputDatoProdotto
                    inputLabel="eMail"
                    datoName='mail'
                    datoId="mail"
                    datoValue={brandTemp.mail ?? ""}
                    datoPlaceHolder=""
                    datoOnChange={handleChange}
                    inputClass={inputClassesNOW + " w-80 h-100"}
                    datoClass={"w-100"}
                    labelClass={"wpx-60"}
                    classiTastoSblocco={classiTastoSblocco}
                    tastoCopiaAspetto="NO"
                    modCompatta="SI"
                    permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                    <InputDatoProdotto
                    inputLabel="cc"
                    datoName='cc'
                    datoId="cc"
                    datoValue={brandTemp.cc ?? ""}
                    datoPlaceHolder=""
                    datoOnChange={handleChange}
                    inputClass={inputClassesNOW + " w-80 h-100"}
                    datoClass={"w-100"}
                    labelClass={"wpx-60"}
                    classiTastoSblocco={classiTastoSblocco}
                    tastoCopiaAspetto="NO"
                    modCompatta="SI"
                    permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                    <InputDatoProdotto
                    inputLabel="cell"
                    datoName='cell'
                    datoId="cell"
                    datoValue={brandTemp.cell ?? ""}
                    datoPlaceHolder=""
                    datoOnChange={handleChange}
                    inputClass={inputClassesNOW + " w-80 h-100"}
                    datoClass={"w-100"}
                    labelClass={"wpx-60"}
                    classiTastoSblocco={classiTastoSblocco}
                    tastoCopiaAspetto="NO"
                    modCompatta="SI"
                    permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    />
                    <InputDatoProdotto
                    inputLabel="cell2"
                    datoName='cell2'
                    datoId="cell2"
                    datoValue={brandTemp.cell2 ?? ""}
                    datoPlaceHolder=""
                    datoOnChange={handleChange}
                    inputClass={inputClassesNOW + " w-80 h-100"}
                    datoClass={"w-100"}
                    labelClass={"wpx-60"}
                    classiTastoSblocco={classiTastoSblocco}
                    tastoCopiaAspetto="NO"
                    modCompatta="SI"
                    permessoScrittura={utente.permessiAPI["update:database"] ? "SI" : "NO"}
                    /> */}
                </div>
                {/* <label for="note" className="w-100 mt3">Note</label>
                        {utente.permessiAPI["update:database"]
                        ? <textarea
                            type="text"
                            rows="5"
                            id="note"
                            name={'note'}
                            value={brandTemp.note ?? ""}
                            onChange={handleChange}
                            className={inputClassesNOW + " w-100"} />
                        : <p>{brandTemp.note ?? ""}</p>
                        } */}
                <div>ID {brandTemp.id}</div>
            </div>
        )
    }

    function associaAFornitore() {
        return(
            <div>
                <ListaAssocia 
                    idElemento1={brandTemp.id}
                    colonnaID1={"id1"}
                    colonnaID2={"id2"}
                    tipoCong={"BF"}
                    tabellaElemento2={"DAM_Fornitori"}
                    riquadroElemento2={listaRiquadriFornitori}
                    height={100}
                    titolo={"Fornitori collegati"}
                    token={token}
                    querySpecifica={"/anagrafiche/ricFornitoreDaIDbrand"}
                    utente={utente}
                />
            </div>
        )
    }

    function riquadroContatti() {
        return(
            <div className="tc sfondoColChiaro">
                <h2 className="sfondoBiancoTema pb3">Contatti collegati</h2>
                <div className="pa3">In questa lista sono presenti i contatti collegati ai fornitori relativi a questo brand. Le operazioni di aggiunta e sottrazione di contatti vanno effettuate dalla scheda del fornitore.</div>
                <div className="pa3">{brandTemp.arrContatti && brandTemp.arrContatti.length>0 && brandTemp.arrContatti.map((c) => <RiquadrinoContatto elemento={c} scelto={true}/>)}</div>
            </div>
        )
    }



    ///// PAGINA


    return (

        <div className={classDivPrincipale}>
            <div className="w-50 ma3-ns br4-ns sfondoBiancoTema flex flex-wrap h-100 h-97-ns">
                    <div className="w-50 dn db-ns pa2-ns pl4-ns pt4-ns pb4-ns datiOrdine">
                        <div className="colonna85vh sezioneConScroll">
                            {riquadroSalvataggio()}
                            {riquadroDatiBrand()}
                            {associaAFornitore()}
                        </div>
                    </div>
                    <div className="w-50 h-100 dn db-ns ba bordinoColoreBianco">
                        <div className="h-100 sezioneConScroll">
                            {riquadroContatti()}
                        </div>
                    </div>
                    {/* <div className="w-40 flex flex-wrap h-100 bl-ns bordoColAlt">
                    <pre className="pa4">{JSON.stringify(brandTemp, null, 2)}</pre>
                </div> */}
                               
            </div>
        </div>

    )
}

export default ModificaBrands;



